module.exports = __webpack_public_path__ + "static/media/emailWhite.7aa125ef.svg";